import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "preparationSelect", "imageGroup", "emptyState", "imageInput" ]

  connect() {
    this.sync()
  }

  preparationChanged() {
    this.sync()
  }

  sync() {
    const selectedPreparationId = this.hasPreparationSelectTarget ? this.preparationSelectTarget.value : ""
    let visibleGroupFound = false

    this.imageGroupTargets.forEach((group) => {
      const matchesSelection = selectedPreparationId !== "" && group.dataset.preparationId === selectedPreparationId
      group.classList.toggle("hidden", !matchesSelection)

      group.querySelectorAll("input[type='radio']").forEach((input) => {
        input.disabled = !matchesSelection
        if (!matchesSelection) input.checked = false
      })

      if (matchesSelection) visibleGroupFound = true
    })

    if (!visibleGroupFound) {
      this.imageInputTargets.forEach((input) => {
        input.checked = false
      })
    }

    if (this.hasEmptyStateTarget) {
      const showEmptyState = selectedPreparationId === "" || !visibleGroupFound
      this.emptyStateTarget.classList.toggle("hidden", !showEmptyState)
    }
  }
}
